import React from 'react';

import PushComponent from '~containers/contact-options/push';

const Push = () => {
  return (
    <div className="c-box">
      <div className="c-box__content">
        <div className="c-editable">
          <PushComponent />
        </div>
      </div>
    </div>
  );
};

export default Push;
